"use strict";

exports.__esModule = true;
exports.getChartColors = getChartColors;
exports.getRandomColors = getRandomColors;
exports.getThemeColors = getThemeColors;

var _color = _interopRequireDefault(require("color"));

var _getRandomColor = require("./getRandomColor");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getChartColors(props) {
  const colors = props.colors,
        theme = props.theme,
        data = props.data;

  if (colors && colors.length) {
    return colors;
  }

  if (theme && theme.primaryColor) {
    return getThemeColors(props);
  }

  return getRandomColors(props);
}

function getRandomColors(props) {
  const data = props.data;
  const steps = data && data.length || 5;
  let colors = [];

  for (let i = 0; i < steps; i++) {
    const color = (0, _getRandomColor.getRandomColor)();
    colors.push(color);
  }

  return colors;
}

function getThemeColors(props) {
  const theme = props.theme,
        data = props.data;
  let primaryColor = theme.primaryColor,
      lightColor = theme.lightColor,
      darkColor = theme.darkColor;

  if (!primaryColor) {
    return undefined;
  }

  if (!lightColor) {
    lightColor = (0, _color.default)(primaryColor).lighten(0.25);
  }

  if (!darkColor) {
    darkColor = (0, _color.default)(primaryColor).darken(0.25);
  }

  const c1 = (0, _color.default)(darkColor);
  const c2 = (0, _color.default)(lightColor);
  const steps = data && data.length || 5;
  let colors = [];

  for (let i = 0; i < steps; i++) {
    const mix = i / steps;
    const color = c1.mix(c2, mix);
    colors.push(color);
  }

  return colors;
}